{
  "Thank you for filling in the form.": "Gracias por completar el formulario.",
  "There was an error in your submission, please try again in a few seconds. If the issue persists, please contact us.": "Ha habido un error en su envío, por favor inténtelo de nuevo en unos segundos. Si el problema persiste, póngase en contacto con nosotros."
}
